var roadmap = new function () {
    this.scrollToQuarter = function () {
        var hash = window.location.hash,
            hash = hash.split('#'),
            quarter = hash[1];

        jQuery('#rmNav').find('option[data-quarter=' + quarter + ']').attr('selected', 'selected');
        jQuery('body').scrollTo('#' + quarter);
    }
    this.setUrlHash = function (quarter, event) {
        event.preventDefault();
        if (quarter == '0') {
            history.pushState("", document.title, window.location.pathname);
            jQuery('body').scrollTo(0);
        } else {
            window.location.hash = quarter;
            // roadmap.scrollToQuarter();
        }
    }
    this.backToTopOfPage = function (e) {
        jQuery('body').scrollTo(0);
        jQuery('#rmNav').find('option:selected').removeAttr('selected');
        jQuery('#rmNav').find('option[value="0"]').attr('selected', true);
        history.pushState("", document.title, window.location.pathname);
    }
    this.wrapRoadmapItems = function () {
        // Wrap roadmap items in container for each quarter
        var roadmapItems = jQuery('.roadmap__item'),
            quarters = {};

        roadmapItems.each(function () {
            quarters[jQuery(this).data('quarter')] = '';
        });

        for (quarter in quarters) {
            roadmapItems.filter('[data-quarter=' + quarter + ']').wrapAll('<div class="quarter" id="' + quarter + '"></div');
            formattedQuarter = quarter.replace('-', ' ');
            jQuery('.quarter[id="' + quarter + '"]').prepend('<h5><span>' + formattedQuarter + '</span><button class="back-to-top">Back to top</button></h5>');
        }
    }
    this.clickHandler = function (quarter, el) {

        const section = document.getElementById(quarter);
        // section.scroll({
        //     behavior: "smooth",
        //     top: "180px"
        // });

        el.addClass('active');
        
        section.scrollIntoView({ behavior: 'smooth' });

        // Now we can scroll the window to this position
        // window.scrollTo(0, offsetTop);

        // $('html, body').scrollTop(section.offsetHeight().top);

        // scroll({
        //     top: offsetTop,
        //     behavior: "smooth"
        // });
    }
}

jQuery(document).ready(function () {
    
    AOS.init();
    
    // On page load add .ready class to various roadmap elements
    jQuery('.roadmap, .roadmap__item, .roadmap__item-content').addClass('ready');

    // On roadmap nav change push specified quarter to URL
    jQuery('#rmNav li a').click(function (e) {
        e.preventDefault();
        $('#rmNav li a').removeClass('active');
        var quarter = jQuery(this).data('quarter');
        // jQuery(this).find('option[value="0"], :selected').attr('selected', false);
        // jQuery(this).find('option[data-quarter="' + quarter + '"]').attr('selected', true);
        roadmap.clickHandler(quarter, $(this));
    });

    // var quarterSelection = document.getElementById("rmNav");

    // quarterSelection.onchange = function (event) {
    //     event.preventDefault();
    //     var quarter = event.target.options[event.target.selectedIndex].dataset.quarter;
    //     roadmap.clickHandler(quarter);
    // }

    jQuery(document).on('click', '.back-to-top', function (e) {
        scroll({
            top: "0",
            behavior: "smooth"
        });
        $('#rmNav li a').removeClass('active');
    });

    roadmap.wrapRoadmapItems();

    // Scroll to specified quarter within URL on page load
    roadmap.scrollToQuarter();

    $('.roadmap__item-content').mouseenter(function () {
        var content = $(this).find('.excerpt p'),
            contentHeight = content.outerHeight();
        $(this).find('.excerpt').stop().animate({
            height: contentHeight
        }, 250);
    }).mouseleave(function () {
        var content = $(this).find('.excerpt p');
        $(this).find('.excerpt').stop().animate({
            height: "0"
        }, 250);
    });

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutationRecord) {
            var element = mutationRecord.target;
            if ($(element).hasClass('ui-hide')) {
                // console.log('nav hidden');
                $('.roadmap-navigation').css('top', '100px');
            } else {
                // console.log('nav visible');
                $('.roadmap-navigation').css('top', '180px');
            }
        });
    });

    var target = document.getElementById('wrapper-navbar');
    observer.observe(target, {
        attributes: true,
        attributeFilter: ['class']
    });

    // Create the dropdown base
    $("<select />").appendTo(".roadmap-navigation");

    // Create default option "Go to..."
    $("<option />", {
        "selected": "selected",
        "value": "",
        "text": "Go to..."
    }).appendTo(".roadmap-navigation select");

    // Populate dropdown with menu items
    $(".roadmap-navigation a").each(function () {
        var el = $(this);
        $("<option />", {
            "value": el.attr("href"),
            "text": el.text()
        }).appendTo(".roadmap-navigation select");
    });

    $(".roadmap-navigation select").change(function () {
        window.location = $(this).find("option:selected").val();
    });
});